module.exports = "/_next/static/images/d8c417da1b7a0dc34d10845e35ec158c-google.svg.webp";